import { campaigns } from 'api';
import {
  GOTO_MARKETPLACE,
  UNSUBSCRIBE_CAMPAIGN,
  UNPUBLISH_CAMPAIGN,
  CAMPAIGN_FRONT_DETAIL_RESET,
  CAMPAIGN_BY_ID,
  FETCH_SECTION_ODATA,
  UPDATE_SECTION_ODATA,
  FETCH_CAR_FEATURES,
  UPDATE_CAR_FEATURES,
  PUBLISH_OMEGA,
  GET_NEW_CAMPAIGN_DATA,
  GOTO_STRATOS_B2C,
  UPDATE_MASTER_DATA_CAMPAIGN,
  VEHICLES_LIBERATION,
  UPDATE_STOCK_RESERVED,
  CAMPAIGNS_CLEAN_OFFER_FAMILY,
  UPDATE_ODATA_BY_DRAG_AND_DROP,
  SAVE_TO_SORT_CAMPAIGN,
  SET_CAMPAIGNS_USE_TO_SORT,
  GET_TEMPLATES_BY_CAMPAIGN,
  CAMPAIGN_GALLERY_BY_ID
} from 'store/actions/campaign';
import { paginationOData, lsGetSelectedCommonFilters } from 'helpers/store';

export default {
  [GOTO_MARKETPLACE]: (param, url) => {
    window.open(url);
  },

  [UNSUBSCRIBE_CAMPAIGN]: ({ commit }, campaignId) =>
    new Promise((resolve, reject) => {
      campaigns.unsubscribe(campaignId).then(
        resp => {
          const data = resp.data;
          resolve(data);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [UNPUBLISH_CAMPAIGN]: ({ commit }, dataUnpublish) =>
    new Promise((resolve, reject) => {
      const campaignId = dataUnpublish.campaignId;
      const marketplaceId = dataUnpublish.marketplaceId;
      campaigns.unpublishCampaign({ campaignId, marketplaceId }).then(
        () => resolve(),
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [CAMPAIGN_BY_ID]: ({ commit }, campaignId) =>
    new Promise((resolve, reject) => {
      campaigns.getCampaignById(campaignId).then(
        resp => {
          const data = resp.data;
          resolve(data);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [CAMPAIGN_FRONT_DETAIL_RESET]: ({ commit }) => commit(CAMPAIGN_FRONT_DETAIL_RESET),

  [FETCH_SECTION_ODATA]: ({ commit }, odataQuery) =>
    new Promise((resolve, reject) => {
      campaigns.getCampaignsOData(odataQuery).then(
        resp => {
          const data = resp.data || [];
          commit(UPDATE_SECTION_ODATA, data);
          resolve(paginationOData(resp).total);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [FETCH_CAR_FEATURES]: ({ commit }, campaignId) =>
    new Promise((resolve, reject) => {
      campaigns.getCarFeatures(campaignId).then(
        resp => {
          const data = resp.data;
          commit(UPDATE_CAR_FEATURES, data);
          resolve();
        },
        err => {
          reject(err);
        }
      );
    }),

  [PUBLISH_OMEGA]: (params, data) =>
    new Promise((resolve, reject) => {
      campaigns.publishOmega(data).then(
        resp => {
          resolve(resp);
        },
        err => {
          if (err.response && err.response.data) {
            const errors = err.response.data;
            delete errors.$id;
            let errorMsg = '';
            const errorsKeys = Object.keys(errors);
            errorsKeys.forEach((item, index) => {
              if (index === errorsKeys.length - 1) {
                errorMsg += `${item}(${errors[item].toString().replace(',', ', ')})`;
              } else {
                errorMsg += `${item}(${errors[item].toString().replace(',', ', ')}), `;
              }
            });
            reject(errorMsg);
          } else {
            reject(new Error('Error'));
          }
        }
      );
    }),

  [GET_NEW_CAMPAIGN_DATA]: ({ commit }, campaignId) =>
    new Promise((resolve, reject) => {
      campaigns.getNewCampaignData(campaignId).then(
        resp => {
          const data = resp.data;
          const masterDataCampaign = {
            initDate16: data.initDate16 === '0001-01-01T00:00:00' ? null : data.initDate16,
            endDate16: data.endDate16 === '0001-01-01T00:00:00' ? null : data.endDate16,
            toDateInvisibility: data.endDate16 === '0001-01-01T00:00:00' ? null : data.endDate16,
            termMileageMatrix: data.termMileageMatrix
          };
          commit(UPDATE_MASTER_DATA_CAMPAIGN, masterDataCampaign);
          resolve(data);
        },
        err => {
          if (err.response.data.code === 409 && err.response.data.errorCode === 1) {
            reject(err.response.data);
          } else {
            commit('ERROR_OCCURRED', err, {
              root: true
            });
            reject();
          }
        }
      );
    }),

  [GOTO_STRATOS_B2C]: (params, data) => {
    const APP_TESLA_URL =
      process.env.APP_TESLA_URL.lastIndexOf('/') !== process.env.APP_TESLA_URL.length - 1
        ? `${process.env.APP_TESLA_URL}/`
        : process.env.APP_TESLA_URL;
    window.open(`${APP_TESLA_URL}${data.campaignId}/${data.partnerId}`);
  },

  [VEHICLES_LIBERATION]: ({ commit }, { campaignId, numberOfVehicles }) =>
    new Promise((resolve, reject) => {
      campaigns
        .vehiclesLiberation({ campaignId, numberOfVehicles })
        .then(resp => {
          commit(UPDATE_STOCK_RESERVED, resp.data.reservedVehicles);
          resolve(resp.data);
        })
        .catch(error => reject(error));
    }),

  [CAMPAIGNS_CLEAN_OFFER_FAMILY]: (params, idOffer) =>
    new Promise((resolve, reject) => {
      campaigns
        .campaignsCleanOfferFamily(idOffer)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    }),

  [SET_CAMPAIGNS_USE_TO_SORT]: ({ commit }, data) => commit(SET_CAMPAIGNS_USE_TO_SORT, data),

  // eslint-disable-next-line no-unused-vars
  [UPDATE_ODATA_BY_DRAG_AND_DROP]: ({ commit }, { newIndex, oldIndex }) => {
    const maxTopCampaigns = lsGetSelectedCommonFilters('partner').maxTopCampaigns;
    commit(UPDATE_ODATA_BY_DRAG_AND_DROP, { newIndex, oldIndex, maxTopCampaigns });
  },

  [SAVE_TO_SORT_CAMPAIGN]: ({ getters }, partnerId) =>
    new Promise((resolve, reject) => {
      campaigns
        .orderCampaign(getters.dataCampaign('sortedCampaigns'), partnerId)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    }),

  // eslint-disable-next-line no-unused-vars
  [GET_TEMPLATES_BY_CAMPAIGN]: ({ commit }, { partnerId, campaignId }) =>
    new Promise((resolve, reject) => {
      campaigns
        .getTemplatesByCampaign({ partnerId, campaignId })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(error => {
          reject(error);
        });
    }),

  [CAMPAIGN_GALLERY_BY_ID]: ({ commit }, campaignId) =>
    new Promise((resolve, reject) => {
      campaigns.getGalleryByCampaignId(campaignId).then(
        resp => {
          const data = resp.data;
          resolve(data);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    })
};
